import { HttpClient } from '@/shared/lib/http-client';

export const fetchTextBlocks = async(page) => {
  const response = await HttpClient.get('/text-blocks', {
    page: page,
    is_active: true,
  });

  return response.data?.data;
};
